import Seo from "@/components/Seo";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { Section, Eyebrow } from "@/components/Bits";
import ImagePlaceholder from "@/components/ImagePlaceholder";
import ArrowLink from "@/components/ArrowLink";
import { RESOURCE_CATEGORIES } from "@/data/site";

export default function Resources() {
  return (
    <>
      <Seo title="Home Education Resources | FreeRange.Education" description="Practical materials designed to support home education without adding unnecessary complexity. The resource library will grow over time." />

      <Section className="pb-16 pt-32 md:pt-40">
        <Reveal>
          <Eyebrow color="text-marigold">Resources</Eyebrow>
          <h1 className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight text-charcoal sm:text-6xl lg:text-7xl">
            Resources
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-charcoal/75">
            Practical materials designed to support home education without adding unnecessary complexity.
          </p>
        </Reveal>
      </Section>

      <Section className="pb-24 md:pb-32">
        <Stagger className="space-y-8">
          {RESOURCE_CATEGORIES.map((c, i) => (
            <StaggerItem key={c.slug}>
              <div
                className="grid items-center gap-8 rounded-[2rem] border border-charcoal/10 bg-white p-6 md:grid-cols-[0.9fr_1.1fr] md:p-8"
                data-testid={`resource-category-${c.slug}`}
              >
                <div className={`group order-1 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <ImagePlaceholder src={c.image} alt={c.title} ratio="wide" rounded="rounded-2xl" testid={`resource-cat-img-${c.slug}`} />
                </div>
                <div className={`${i % 2 === 1 ? "md:order-1" : ""}`}>
                  <span className="font-display text-4xl font-extrabold text-charcoal/15">0{i + 1}</span>
                  <h2 className="mt-2 font-display text-3xl font-bold tracking-tight text-charcoal">{c.title}</h2>
                  <p className="mt-3 max-w-lg text-lg leading-relaxed text-charcoal/70">{c.body}</p>
                  <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-sand px-4 py-2 text-sm font-semibold text-charcoal/60">
                    More resources coming soon
                  </span>
                </div>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal className="mt-14 rounded-[2rem] bg-purple p-10 text-cream md:p-14">
          <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl">
            The library is just getting started.
          </h2>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-cream/80">
            We're building this resource library carefully, adding downloads and templates as they're ready — rather
            than filling it with things you don't need. Have something you'd find useful?
          </p>
          <div className="mt-8">
            <ArrowLink to="/contact" variant="turquoise" testid="resources-contact-cta">Suggest a resource</ArrowLink>
          </div>
        </Reveal>
      </Section>
    </>
  );
}
